'use strict';

exports.__esModule = true;

exports.default = function () {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof navigator !== 'undefined' && navigator.userAgent;

    return (/Android|webOS|iPhone|iP[ao]d|BlackBerry|IEMobile|Opera Mini|Windows Phone|SymbianOS/i.test(ua)
    );
};


//////////////////
// WEBPACK FOOTER
// ./~/usfl/platform/mobile.js
// module id = 546
// module chunks = 104101334113578